/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
function add_to_cart(temp){
    $(".Header__CartDot").addClass('Add_ToCart');
  var href = $("#"+temp).attr('href');
  $("#"+temp).removeAttr('href');
  $("#svg-"+temp).hide();
  $("#circle-"+temp).show();
  $(".hidden-tablet-and-up #svg-"+temp ).hide();
  var qty=$(".Header__CartCount").html();
  
  qty=parseInt(qty);
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add',
    data: {
      quantity: 1,
      id: temp
    },
    dataType: 'json',           
    success: function() {
      $(".Header__CartDot").addClass('is-visible');
      $("#svg-"+temp).show();
      $(".hidden-tablet-and-up #svg-"+temp ).show();
      $("#circle-"+temp).hide();
      $(".Header__CartCount").html(qty+1);
      $(".Header__CartDot").html(qty+1);
            $(".Header__CartDot").removeClass('Add_ToCart');  

      $("#"+temp).attr('href',href);  
      
document.dispatchEvent(new CustomEvent('product:update', {
              bubbles: true,
              detail: {
                variant: temp,
                quantity: 1
              }
            }));
    },
    error: function() {
      $("#"+temp).attr('href',href); 
      alert('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
    }

  });  
}
function popclose(){
   $("#popupmessage").hide();
}